import { render, staticRenderFns } from "./DotInMotion.vue?vue&type=template&id=7bcddac0&scoped=true&"
var script = {}
import style0 from "./DotInMotion.vue?vue&type=style&index=0&id=7bcddac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcddac0",
  null
  
)

export default component.exports